// components
import React from 'react';
import { Typography, Box } from '@mui/material';
import { Icon } from '@iconify/react';
import CarouselImages from '../components/CarouselImages';
import Page from '../components/Page';
import Publications from '../components/Publications';
import pdfarchivo from '../SamplePDF.pdf';
// ----------------------------------------------------------
const tituloPublicacion = "Publicaciones";

const arrayPublications = [
  {
    id: 1,
    title: 'titulo 1',
    info:`<p> información 1 </p>` ,
    image: '/static/mock-images/covers/cover_8.jpg',
    pdf: null
  },
  {
    id: 2,
    title: 'titulo 2 titulo 2',
    info: 'información 2',
    image: null,
    pdf: pdfarchivo,
  },
  {
    id: 3,
    title: 'titulo 3 titulo 3 titulo 3',
    info: 'información 3',
    image: '/static/mock-images/covers/cover_6.jpg',
    pdf: null
  },
  {
    id: 4,
    title: 'titulo 4',
    info: 'información 4',
    image: '/static/mock-images/covers/cover_5.jpg',
    pdf: null
  },
  {
    id: 5,
    title: 'titulo 5',
    info: 'información 5',
    image: '/static/mock-images/covers/cover_4.jpg',
    pdf: null
  },
];
// ----------------------------------------------------------

export default function DashboardApp() {
  const items = [
    {
      title: 'Junta Local de Sanidad Vegetal de Río Bravo',
      resume:
        'Somos productores que pertenecemos a un Organismo Auxiliar de Sanidad Vegetal que pertenece a la Secretaría de Desarrollo Rural del Gobierno Federal, que aplicamos lo establecido en la Ley Federal de Sanidad Vegetal en el renglón Fitosanitario.',
      image:
        'https://www.relocationsrs.com.mx/wp-content/uploads/2018/11/SRS-agricultura-Colombia-2018-720x340.jpg',
      info: '<h2><strong>Misión</strong></h2><p>Operar las diferentes campañas y programas fitosanitarias mediante el análisis de riesgo, impacto económico y un diagnóstico científico, que permita aplicar estrategias de un manejo integrado que incluya la prevención y el uso de los diferentes sistemas de control, encaminados a la prevención, contención y erradicación de plagas de importancia cuarentenaria&nbsp; para establecer áreas libres y de baja prevalencia de organismos plaga, y la aplicación del programa de Inocuidad Agrícola, que se traduzca en beneficios económicos para los productores Agrícolas de Tamaulipas.</p><p><br/></p><h2><strong>Visión</strong></h2><p>Ser el conducto de los productores de Tamaulipas en la prevención, control y combate de organismos plaga y la aplicación de los sistemas de reducción de riesgos de contaminación, que permitan comercializar sus productos sin restricciones de carácter fitosanitario a los mercados nacionales y de exportación, que sirva para nuestros nuevos productores como modelo a seguir, aplicando los sistemas científicos relacionados con la materia.</p><p><br/></p><h2><strong>¿Quiénes Somos?</strong></h2><p>Somos productores que pertenecemos a un Organismo Auxiliar de Sanidad Vegetal que pertenece a la Secretaría de Desarrollo Rural del Gobierno Federal, que aplicamos lo establecido en la Ley Federal de Sanidad Vegetal en el renglón Fitosanitario.</p><p><br/></p><h2><strong>Política de Calidad</strong></h2><p>Nuestra política dentro del renglón fitosanitario que esta Junta Local de Sanidad Vegetal de Rio Bravo tiene, es ser eficiente en la aplicación de la normatividad que emita el SENASICA y las leyes y reglamentos vigentes para la operatividad de las campañas&nbsp; dentro de nuestra área de influencia.</p><p><br/></p><h2><strong>Objetivos</strong></h2><p>Nuestro objetivo es operar las diferentes campañas fitosanitarias establecidas por el SENASICA&nbsp; dentro de la Junta Local de Sanidad Vegetal de Rio Bravo, Tamaulipas y las acciones y sub acciones que cada una comprende con el fin de evitar daños a la producción orientando a los productores en cuanto al manejo integrado de las plagas, que redunde en elevar la producción y la calidad de sus cosechas y por ende que sea un beneficio para la economía de cada uno de ellos.</p><p><br/></p><h2><strong>Funciones</strong></h2><p>Dentro de las funciones que tienen los directicos de la Junta Local de Sanidad Vegetal&nbsp; es aplicar las medidas fitosanitarias relacionadas con las campañas fitosanitarias, los programas y los sistemas de reducción de riesgos de contaminación en a producción primaria de vegetales que tiene el SENASICA y todas aquellas relacionadas con la sanidad vegetal que permitan e4stablecer áreas libres y de baja prevalencia en el renglón de plagas cuarentenales y aquellas que no están presentes dentro del País, así como ser los principales promotores de la Sanidad Vegetal y los sistemas de reducción de riesgo de contaminantes.</p><p><br/></p><h2><strong>Valores</strong></h2><p>Dentro de los valores que se tienen en esta Junta Local de Sanidad Vegetal es aplicar irrestrictamente todas las medidas fitosanitarias que se encuentran establecidas dentro de las normas, leyes y reglamentos siempre con honestidad y pulcritud y transparencia que se refleje en el manejo eficiente, tanto operativo como administrativo de esta junta local. </p>'
    }
  ];

  const settings = {
    autoPlay: false,
    indicators: true,
    swipe: true,
    cycleNavigation: true,
    navButtonsAlwaysVisible: true,
    navButtonsAlwaysInvisible: false,
    fullHeightHover: true,
    animation: 'fade',
    duration: '500'
  };

  return (
    <Page title="Inicio">
      <br />
      <img alt="register" src="/static/sitio_construccion.png" style={{ marginLeft: 'auto',marginRight: 'auto',display: 'block' }}/>

      {/* <Box>
        <Icon icon="eva:alert-triangle-outline" />
        <Typography variant='h1' fontFamily="monospace" fontWeight="light" textAlign='center'>
          Sitio en construcción
        </Typography>
      </Box> */}
      <br />
      <br />
      <CarouselImages CarouselSettings={settings} arrayElements={items} />
      <br />
    </Page>
  );
}
